import {
  BuildOutlined,
  LineChartOutlined,
  MessageOutlined,
} from '@ant-design/icons';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import styled from 'styled-components';

import { Flex, Space, VFlex } from '@/components/base';
import Button from '@/components/Button/Button';
import Heading from '@/components/Typography/Heading';
import Typo from '@/components/Typography/Typo';
import useWorkspaceRouter from '@/hooks/domain/useWorkspaceRouter';
import useUIStore from '@/stores/pure/UIStore';

const WorkspaceSettingComplete = () => {
  const wr = useWorkspaceRouter();
  const [searchParams] = useSearchParams();
  const setSidebarHidden = useUIStore((state) => state.setSidebarHidden);

  const wa = searchParams.get('workspace_alias');

  const onExploreClick = () => {
    if (!wa) return;
    wr.navigate(`/workspace/${wa}/home`);
    setSidebarHidden(false);
  };
  useEffect(() => {
    setSidebarHidden(true);
  }, [setSidebarHidden]);

  if (!wa) return null;

  return (
    <Style>
      <img
        width={120}
        height={120}
        src="/assets/logo-syncly.svg"
        alt="syncly"
      />
      <Space h={16} />
      <Heading type="h1" style={{ fontSize: 32 }}>
        Let's start using Syncly
      </Heading>
      <Space h={54} />
      <Flex g={24}>
        <FeatureItem>
          <MessageOutlined />
          <Space h={24} />
          <Typo type="label0" weight="b">
            Integration
          </Typo>
          <Space h={8} />
          <Typo type="body2">Ingest data automatically</Typo>
        </FeatureItem>
        <FeatureItem>
          <BuildOutlined />
          <Space h={24} />
          <Typo type="label0" weight="b">
            Taxonomy
          </Typo>
          <Space h={8} />
          <Typo type="body2">Let AI classify</Typo>
        </FeatureItem>
        <FeatureItem>
          <LineChartOutlined />
          <Space h={24} />
          <Typo type="label0" weight="b">
            Dashboards
          </Typo>
          <Space h={8} />
          <Typo type="body2">Create & share insights</Typo>
        </FeatureItem>
      </Flex>
      <Space h={72} />
      <Button style={{ width: 200 }} sizeType="l" onClick={onExploreClick}>
        Explore
      </Button>
    </Style>
  );
};

const Style = styled(VFlex)`
  padding: 40px 30px 48px;
  align-items: center;
`;

const FeatureItem = styled(VFlex)`
  flex: 1;
  color: ${(props) => props.theme.colors.gray700};
  font-size: 24px;
  padding: 12px;
  border: 1px solid ${(props) => props.theme.colors.gray300};
  border-radius: 8px;
`;

export default WorkspaceSettingComplete;
